import React from 'react'
import 'antd/lib/date-picker/style/index.css'
import moment from 'moment'
import { DatePicker } from 'antd'

const { RangePicker } = DatePicker

const FilterUpdateAt = ({ handleChangeDate, updated }) => {
    let timeout = 0

    const _handleDateChange = async (date, dateString) => {
        const [from, to] = dateString

        if (timeout) {
            clearTimeout(timeout)
        }

        if (typeof handleChangeDate === 'function') {
            const filters = Object.assign({}, updated)

            filters.update_at = {
                from,
                to
            }

            if (!to && !from) {
                delete filters.update_at
            }

            await handleChangeDate(filters)
        }
    }

    return (
        <div className='FilterUpdateAt'>
            <label className='font-weight-bold d-block'>Updated at</label>
            <RangePicker
                placeholder={['Ngày bắt đầu', 'Ngày kết thúc']}
                value={[updated.update_at !== undefined ? moment(updated.update_at.from, 'DD/MM/YYYY') : '', updated.update_at !== undefined ? moment(updated.update_at.to, 'DD/MM/YYYY') : '']}
                ranges={{
                    'Today': [moment(), moment()],
                    'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                }}
                format={'DD/MM/YYYY'}
                onChange={_handleDateChange}
                className="w-100"
            />
        </div>
    )
}

export default FilterUpdateAt